export default __webpack_public_path__ + "static/media/featSportMb.5a0c06f5.png";